export default __webpack_public_path__ + "static/restaurant-cafe-6d254b4ec5543f58defcec724e0ca0c0.jpg";